import { useState, useEffect } from 'react'
import { navigationData } from '../../data'

export default function Navbar(): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [scrolled, setScrolled] = useState<boolean>(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleNavClick = (item: { name: string; href: string; external?: boolean }) => {
    if (item.external) {
      // Open external link in new tab
      window.open(item.href, '_blank', 'noopener,noreferrer')
    } else {
      // Scroll to section for internal links
      const element = document.querySelector(item.href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
    setIsOpen(false)
  }

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-portfolio-black/90 backdrop-blur-md border-b border-gray-800' : 'bg-transparent'
      }`}
    >
      <div className="container">
        <div className="flex items-center justify-between h-16">
          <a
            href={navigationData.brand.href}
            className="text-2xl font-bold text-white hover:text-green-400 transition-colors"
          >
            {navigationData.brand.name.split('.')[0]}<span className="text-green-400">.</span>{navigationData.brand.name.split('.')[1]}
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            {navigationData.navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item)}
                className="text-gray-300 hover:text-green-400 transition-colors font-medium"
              >
                {item.name}
              </button>
            ))}
          </div>

          {/* Mobile Navigation Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white hover:text-green-400 transition-colors"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isOpen && (
        <div className="md:hidden bg-portfolio-black/95 backdrop-blur-md border-t border-gray-800">
          <div className="container py-4">
            <div className="flex flex-col space-y-4">
              {navigationData.navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item)}
                  className="text-left text-gray-300 hover:text-green-400 transition-colors font-medium py-2"
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  )
} 